import type { FC } from 'react';
import React, { memo } from 'react';
import { MoneyInput } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';
import { MAX_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT } from '@pflegenavi/shared/constants';

interface LineItemAmountInputProps {
  value: number | undefined;
  handleSetLineItemAmount: (amount: number) => void;
  handleResetLineItemAmount: () => void;
}

export const LineItemAmountInput: FC<LineItemAmountInputProps> = memo(
  ({ value, handleSetLineItemAmount, handleResetLineItemAmount }) => {
    const { t } = useTranslation();
    return (
      <MoneyInput
        size="small"
        placeholder={t('receipts.batch.form.resident-quick-selection.amount')}
        value={value}
        maxValue={MAX_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT}
        sx={{
          '& .MuiInputBase-root.MuiOutlinedInput-root': {
            borderColor: 'primary.main',
            borderWidth: 1,
          },
        }}
        onChange={(newAmount) => {
          if (newAmount) {
            handleSetLineItemAmount(newAmount);
          } else {
            handleResetLineItemAmount();
          }
        }}
      />
    );
  }
);
